// const DEBUG =
import Bugsnag from '@/plugins/bugsnag';
import { useAuthStore } from '@/stores/auth.store.js';
import { useNProgress } from '@vueuse/integrations/useNProgress';

const { isLoading } = useNProgress();

const errorInterceptor = (axiosInterceptor) => {
  axiosInterceptor.interceptors.response.use(
    (response) => {
      isLoading.value = false;
      if (response.status === 200 || response.status === 201) {
        return Promise.resolve(response);
      } else {
        return Promise.reject(response);
      }
    },
    (error) => {
      isLoading.value = false;

      // Log the error to Bugsnag with additional context
      Bugsnag.notify(error, (event) => {
        event.addMetadata('api', {
          url: error.config?.url,
          method: error.config?.method,
          status: error.response?.status,
          responseData: error.response?.data,
        });
      });

      switch (error?.response?.status) {
        case 400:
          // send out error response
          console.log(error?.response?.data);
          return Promise.reject(error);
        case 401:
          useAuthStore().logout();
          // if (!vue.config.devtools) {
          //   // clear user from auth store & logout
          //   //store.dispatch("clearAuthUser");
          // }
          // getActivePinia()._s.forEach((store) => store.$reset()) // clear all stores
          // router.push({ name: 'login' }).catch(() => {})
          break;
        // case 403:
        //     if (!Vue.config.devtools) {
        //         store.dispatch("clearAuthUser");
        //         router.push({ name: "Login" }).catch(() => {});
        //     }
        //     break;
        // case 500:
        //     if (!Vue.config.devtools) {
        //         setTimeout(() => {
        //             store.dispatch("clearAuthUser");
        //             router.push({ name: "Login" }).catch(() => {});
        //         }, 1000);
        //     }
        //     break;
        // case 502:
        //     if (!Vue.config.devtools) {
        //         setTimeout(() => {
        //             store.dispatch("clearAuthUser");
        //             router.push({ name: "Login" }).catch(() => {});
        //         }, 1000);
        //     }
      }

      return Promise.reject(error);
    }
  );
};

export default errorInterceptor;
